import { Button, Modal } from '@paysense-india-services/elevate-web'

const LogoutModal = ({ show, onClose, onLogout, subScreen }) => {
  const bottomSheet = subScreen?.bottomSheet
  const actions = subScreen?.actions

  const handleLogout = () => {
    onClose()
    onLogout()
  }

  return (
    <Modal elevation='100' onOverlayClick={onClose} show={show} showCross={false}>
      <div className='ew-d-flex ew-flex-column ew-gap-16'>
        <div className='ew-d-flex ew-flex-column ew-gap-10'>
          <div className='ew-typography-large ew-fw-bold ew-color-primary'>
            {bottomSheet?.title ?? 'Logout?'}
          </div>
          {bottomSheet?.subtitle ? (
            <div className='ew-typography-small ew-color-secondary ew-fw-regular'>
              {bottomSheet.subtitle}
            </div>
          ) : null}
        </div>
        <div className='ew-d-flex ew-flex-column ew-gap-16 ew-mt-8'>
          {actions?.secondary ? (
            <Button className='ew-flex-grow-1' onClick={onClose} size='medium' variant='secondary'>
              {actions.secondary.text ?? 'Stay'}
            </Button>
          ) : null}
          {actions?.primary ? (
            <Button className='ew-flex-grow-1' onClick={handleLogout} size='medium' variant='brand'>
              {actions.primary.text ?? 'Logout'}
            </Button>
          ) : null}
        </div>
      </div>
    </Modal>
  )
}

export default LogoutModal
